export default __webpack_public_path__ + "static/media/SAVE_20210603_174328.fe806b3e.jpg";